module.exports = __webpack_public_path__ + "fonts/Freude-Normal.20e84099.woff2";